import { useMemo } from 'react';
import { AText, Box } from '@alf/uikit';
import {
  useCurrencyConvertation,
  useGetCurrencySymbol,
  useGetFormattedAmount
} from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { PREWAGER_BONUS_TYPE, progressBarStates } from '../../../../constants';

import styles from '../../index.module.css';

const ProgressTitle = ({ bonus, status }) => {
  const { t } = useI18n();
  const {
    currency,
    outputBetTotal,
    outputMaxTotal,
    bonusType,
    wageredPercent
  } = bonus;
  const getCurrencySymbol = useGetCurrencySymbol();
  const currencySymbol = getCurrencySymbol(currency);
  const valuePercent = useMemo(
    () => Math.floor((outputBetTotal / outputMaxTotal) * 100),
    [outputBetTotal, outputMaxTotal]
  );

  const { convertationEnabled, getConvertedAmount } = useCurrencyConvertation();
  const { amounts: convertedAmount, currency: convertedCurrency } =
    getConvertedAmount({
      amount: `${outputBetTotal}`,
      additionalFormatting: true,
      currency
    });
  const getFormattedAmount = useGetFormattedAmount();

  return (
    <>
      {status === progressBarStates.EXPIRED &&
        bonusType !== PREWAGER_BONUS_TYPE && (
          <AText breed="B" size="m" color="po_txt_color_1" align="center">
            {t('web.personaloffice.bonuses.wagered.timeOver')}
          </AText>
        )}
      <Box>
        <AText
          breed="R"
          size="s"
          color="po_txt_color_3"
          className={styles.percentTitle}
        >
          {t(
            `web.personaloffice.bonuses.wagered.${
              bonusType === PREWAGER_BONUS_TYPE ? 'title' : 'percent'
            }`
          )}
        </AText>
        <AText breed="B" size="s" color="po_txt_color_1">
          {bonusType === PREWAGER_BONUS_TYPE ? (
            <>
              <AText size="s" breed="B" color="po_txt_color_1">
                {outputBetTotal.toFixed(2)}
              </AText>
              <AText size="s" breed="B" color="po_txt_color_3">
                {` /${getFormattedAmount(
                  outputMaxTotal
                )} ${currencySymbol} (${Math.floor(wageredPercent)}%)`}
              </AText>
            </>
          ) : (
            t('web.personaloffice.bonuses.wagered.percent.value', [
              valuePercent,
              getFormattedAmount(outputBetTotal),
              `${currencySymbol} ${
                convertationEnabled
                  ? ` | ${convertedAmount} ${convertedCurrency}`
                  : ''
              }`
            ])
          )}
        </AText>
      </Box>
    </>
  );
};

export default ProgressTitle;
